import {VehicleForm as VFKit} from '../VehicleForm';

export function ServiceInspectionGroup() {
  return (
    <>
      <VFKit.LastServiceDatePicker />
      <VFKit.SimpleNumericField name="lastServiceMileage" />
      <VFKit.NextServiceDatePicker />
      <VFKit.SimpleNumericField name="nextServiceMileage" />
    </>
  );
}
